const translations = {
  en: {
    // Layout / Navigation
    'nav.dashboard': 'Dashboard',
    'nav.assigned_tasks': 'Assigned Tasks',
    'nav.training': 'Training',
    'nav.leaderboard': 'Leaderboard',
    'nav.shorts': 'Shorts',
    'nav.certificates': 'Certificates',
    'nav.profile': 'Profile',
    'nav.analytics': 'Analytics',
    'nav.modules': 'Modules',
    'nav.categories': 'Categories',
    'nav.assignments': 'Assignments',
    'nav.associates': 'Associates',
    'nav.managers': 'Managers',
    'nav.thumbnails': 'Thumbnails',
    'nav.associate_view': 'Associate View',
    'nav.reviews': 'Open Answer Reviews',
    'nav.skill_matrix': 'Training Matrix',
    'nav.sops': 'SOPs & Visual Aids',
    'nav.portal_accounts': 'Customer & Demo Access',
    'page.portal_analytics': 'Account Analytics',
    'page.portal_associates': 'Associates',
    'page.portal_accounts': 'Customer & Demo Access',
    'nav.observations': 'Observations',
    'nav.training_signoff': 'Training Sign-Off',
    'nav.pit_licenses': 'PIT Licenses',
    'nav.kaizens': 'Kaizens',
    'nav.meetings': 'Meetings',
    'nav.buildings': 'Buildings',
    'nav.media_library': 'Media Library',
    'nav.sign_out': 'Sign Out',
    'nav.ind4_training': 'Operations Academy',
    'nav.dashboard_subtitle': 'Training Dashboard',

    // Page titles
    'page.dashboard': 'Dashboard',
    'page.assigned_tasks': 'Assigned Tasks',
    'page.training_modules': 'Training Modules',
    'page.module_viewer': 'Module Viewer',
    'page.my_certificates': 'My Certificates',
    'page.certificate': 'Certificate',
    'page.my_profile': 'My Profile',
    'page.leaderboard': 'Leaderboard',
    'page.shorts': 'Training Shorts',
    'page.manage_managers': 'Manage Managers',
    'page.category_thumbnails': 'Category Thumbnails',
    'page.manage_categories': 'Manage Categories',
    'page.admin_analytics': 'Admin Analytics',
    'page.manage_modules': 'Manage Modules',
    'page.manage_assignments': 'Manage Assignments',
    'page.manage_associates': 'Manage Associates',
    'page.open_answer_reviews': 'Open Answer Reviews',
    'page.skill_matrix': 'Training Matrix',
    'page.sops': 'SOPs & Visual Aids',
    'page.media_library': 'Media Library',
    'page.ind4_training': 'Operations Academy',

    // Login
    'login.title': 'Operations Academy',
    'login.subtitle': 'Training Dashboard',
    'login.sign_in': 'Sign In',
    'login.description': 'Enter your credentials to access your training dashboard',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.email_placeholder': 'you@example.com',
    'login.password_placeholder': 'Enter your password',
    'login.signing_in': 'Signing in...',
    'login.submit': 'Sign In',
    'login.no_account': "Don't have an account?",
    'login.register_link': 'Register here',
    'login.welcome_back': 'Welcome back, {name}!',
    'login.fill_fields': 'Please fill in all fields',
    'login.invalid': 'Invalid credentials',

    // Register
    'register.title': 'Operations Academy',
    'register.subtitle': 'Training Dashboard',
    'register.heading': 'Register',
    'register.description': 'Enter your details to create an associate account',
    'register.full_name': 'Full Name',
    'register.email': 'Email',
    'register.job_title': 'Job Title',
    'register.password': 'Password',
    'register.confirm': 'Confirm',
    'register.name_placeholder': 'John Doe',
    'register.email_placeholder': 'you@example.com',
    'register.password_placeholder': 'Min 6 chars',
    'register.confirm_placeholder': 'Confirm',
    'register.select_job': 'Select your job title',
    'register.creating': 'Creating account...',
    'register.submit': 'Create Account',
    'register.has_account': 'Already have an account?',
    'register.login_link': 'Sign in',
    'register.fill_required': 'Please fill in all required fields',
    'register.passwords_mismatch': 'Passwords do not match',
    'register.password_length': 'Password must be at least 6 characters',
    'register.success': 'Account created successfully!',
    'register.failed': 'Registration failed',
    // Job titles
    'job.director': 'Director',
    'job.equipment_operator': 'Equipment Operator',
    'job.inventory_specialist': 'Inventory Specialist',
    'job.manager': 'Manager',
    'job.quality_control': 'Quality Control',
    'job.supervisor': 'Supervisor',
    'job.team_lead': 'Team Lead',

    // Dashboard
    'dashboard.welcome': 'Welcome back, {name}',
    'dashboard.overview': "Here's your training progress overview",
    'dashboard.total_modules': 'Total Modules',
    'dashboard.completed': 'Completed',
    'dashboard.in_progress': 'In Progress',
    'dashboard.certificates': 'Certificates',
    'dashboard.overall_progress': 'Overall Progress',
    'dashboard.modules_completed': '{completed} of {total} modules completed',
    'dashboard.your_points': 'Your Points',
    'dashboard.view_leaderboard': 'View Leaderboard',
    'dashboard.total_points': 'Total points earned',
    'dashboard.per_module': '+{n} per module',
    'dashboard.per_quiz': '+{n} per quiz',
    'dashboard.perfect_bonus': '+{n} perfect bonus',
    'dashboard.badges_earned': 'Badges Earned',
    'dashboard.earn_first_badge': 'Complete modules to earn your first badge!',
    'dashboard.pending_trainings': 'Pending Trainings',
    'dashboard.all_completed': 'All trainings completed! Great job.',
    'dashboard.recent_certificates': 'Recent Certificates',
    'dashboard.no_certificates': 'No certificates yet. Complete a training to earn one!',
    'dashboard.view_all_training': 'View All Training Modules',

    // Status badges
    'status.not_started': 'Not Started',
    'status.completed': 'Completed',
    'status.quiz_ready': 'Quiz Ready',
    'status.retry': 'Retry',
    'status.retry_quiz': 'Retry Quiz',
    'status.in_progress': 'In Progress',
    'status.overdue': 'Overdue',
    'status.active': 'Active',
    'status.inactive': 'Inactive',

    // Training
    'training.title': 'Training Modules',
    'training.subtitle': 'Browse and complete your required training modules',
    'training.modules': 'modules',
    'training.completed_of': '{completed}/{total} completed',
    'training.all': 'All',
    'training.no_modules': 'No modules available in this category yet.',
    'training.admin_add_soon': 'Admin will add training modules soon.',
    'training.quiz_questions': '{n} quiz questions',
    'training.review': 'Review',
    'training.continue': 'Continue',
    'training.start': 'Start',

    // Profile
    'profile.joined': 'Joined {date}',
    'profile.completed': 'Completed',
    'profile.in_progress': 'In Progress',
    'profile.certificates': 'Certificates',
    'profile.points': 'Points',
    'profile.badges_earned': 'Badges Earned',
    'profile.tab_completed': 'Completed',
    'profile.tab_active': 'Active',
    'profile.tab_certificates': 'Certificates',
    'profile.no_completed': 'No completed trainings yet.',
    'profile.no_active': 'No active trainings.',
    'profile.no_certificates': 'No certificates yet. Complete trainings to earn certificates!',
    'profile.score': 'Score',
    'profile.picture_updated': 'Profile picture updated!',
    'profile.picture_failed': 'Failed to update profile picture',
    'profile.image_too_large': 'Image must be under 2MB',

    // Leaderboard
    'leaderboard.title': 'Leaderboard',
    'leaderboard.subtitle': 'See how you rank among your teammates',
    'leaderboard.you': 'You',
    'leaderboard.no_department': '',
    'leaderboard.pts': 'pts',
    'leaderboard.modules': 'modules',
    'leaderboard.badges': 'badges',
    'leaderboard.all_associates': 'All Associates',
    'leaderboard.no_associates': 'No associates yet.',
    'leaderboard.points': 'points',

    // Assigned Tasks
    'assigned.title': 'Assigned Tasks',
    'assigned.subtitle': 'Training modules assigned to you by your administrator',
    'assigned.progress': 'Assignment Progress',
    'assigned.tasks_completed': '{completed} of {total} assigned tasks completed',
    'assigned.no_tasks': 'No assigned tasks yet.',
    'assigned.admin_will_assign': 'Your administrator will assign training modules to you.',
    'assigned.assigned_date': 'Assigned {date}',
    'assigned.due_date': 'Due {date}',

    // Certificates List
    'certs.title': 'My Certificates',
    'certs.subtitle': 'View and download your earned certificates',
    'certs.no_certs': 'No certificates earned yet.',
    'certs.earn_certs': 'Complete training modules and pass assessments to earn certificates.',
    'certs.score': 'Score',

    // Admin Associates
    'admin_assoc.title': 'Associates',
    'admin_assoc.subtitle': 'Manage associate profiles and track their progress',
    'admin_assoc.all': 'All',
    'admin_assoc.active': 'Active',
    'admin_assoc.inactive': 'Inactive',
    'admin_assoc.name': 'Name',
    'admin_assoc.email': 'Email',
    'admin_assoc.department': 'Department',
    'admin_assoc.status': 'Status',
    'admin_assoc.completed': 'Completed',
    'admin_assoc.in_progress': 'In Progress',
    'admin_assoc.joined': 'Joined',
    'admin_assoc.actions': 'Actions',
    'admin_assoc.no_associates': 'No associates registered yet.',
    'admin_assoc.no_filter': 'No {filter} associates.',
    'admin_assoc.edit_title': 'Edit Associate',
    'admin_assoc.account_status': 'Account Status',
    'admin_assoc.active_employed': 'Active — Currently employed',
    'admin_assoc.inactive_terminated': 'Inactive — Terminated',
    'admin_assoc.unable_login': 'This associate will be unable to log in.',
    'admin_assoc.reset_password': 'Reset Password',
    'admin_assoc.password_placeholder': 'Leave blank to keep current password',
    'admin_assoc.password_length': 'Password must be at least 6 characters',
    'admin_assoc.cancel': 'Cancel',
    'admin_assoc.update': 'Update',
    'admin_assoc.saving': 'Saving...',
    'admin_assoc.name_email_required': 'Name and email are required',
    'admin_assoc.deactivated': 'Associate deactivated successfully',
    'admin_assoc.reactivated': 'Associate reactivated successfully',
    'admin_assoc.updated': 'Associate updated',
    'admin_assoc.updated_password': 'Associate updated & password reset',
    'admin_assoc.failed_fetch': 'Failed to fetch associates',
    'admin_assoc.failed_update': 'Failed to update',
    'admin_assoc.failed_status': 'Failed to update status',
    'admin_assoc.delete_confirm': 'Delete this associate? This will remove all their progress and certificates.',
    'admin_assoc.deleted': 'Associate deleted',
    'admin_assoc.failed_delete': 'Failed to delete associate',
    'admin_assoc.deactivated_name': '{name} deactivated',
    'admin_assoc.reactivated_name': '{name} reactivated',

    // Admin Dashboard / Analytics
    'admin_dash.title': 'Analytics Dashboard',
    'admin_dash.total_associates': 'Total Associates',
    'admin_dash.total_modules': 'Total Modules',
    'admin_dash.completions': 'Completions',
    'admin_dash.certificates_issued': 'Certificates Issued',
    'admin_dash.category_progress': 'Category Progress',
    'admin_dash.modules_label': 'modules',
    'admin_dash.completions_label': 'completions',
    'admin_dash.assessment_stats': 'Assessment Statistics',
    'admin_dash.avg_score': 'Average Score',
    'admin_dash.total_attempts': 'Total Attempts',
    'admin_dash.pass_rate': 'Pass Rate',
    'admin_dash.passed': 'Passed',
    'admin_dash.failed': 'Failed',
    'admin_dash.recent_completions': 'Recent Completions',
    'admin_dash.export_excel': 'Export to Excel',
    'admin_dash.no_data': 'No completion data yet.',

    // Admin Modules
    'admin_mod.title': 'Training Modules',
    'admin_mod.create': 'Create Module',
    'admin_mod.questions': 'questions',
    'admin_mod.completions': 'completions',
    'admin_mod.edit': 'Edit',
    'admin_mod.delete': 'Delete',
    'admin_mod.no_modules': 'No modules created yet.',

    // Admin Assignments
    'admin_assign.title': 'Assignments',
    'admin_assign.create': 'Create Assignment',
    'admin_assign.no_assignments': 'No assignments yet.',

    // Admin Managers
    'admin_mgr.title': 'Managers',
    'admin_mgr.no_managers': 'No managers yet.',

    // Assessment PDF
    'assessment.title': 'Assessments',
    'assessment.download_pdf': 'Download PDF',
    'assessment.view_assessments': 'View Assessments',
    'assessment.no_assessments': 'No assessments completed yet.',
    'assessment.score': 'Score',
    'assessment.attempts': 'Attempts',
    'assessment.result': 'Result',
    'assessment.passed': 'Passed',
    'assessment.failed': 'Failed',
    'assessment.download': 'Download',
    'assessment.assessments_for': 'Assessments for {name}',
    'assessment.close': 'Close',
    'assessment.downloading': 'Downloading...',

    // Notifications
    'notif.title': 'Notifications',
    'notif.mark_all_read': 'Mark all read',
    'notif.no_notifications': 'No notifications yet',
    'notif.you_are_caught_up': "You're all caught up!",

    // Common
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.loading': 'Loading...',
    'common.score': 'Score',
    'common.search_placeholder': 'Search...',

    // Search
    'search.modules_placeholder': 'Search modules by title, category...',
    'search.associates_placeholder': 'Search by name, email...',

    // Coaching
    'coaching.title': 'AI Training Coach',
    'coaching.subtitle': 'Ask me anything about your training!',
    'coaching.input_placeholder': 'Ask about safety, equipment, processes...',
    'coaching.send': 'Send',
    'coaching.thinking': 'Thinking...',
    'coaching.new_chat': 'New Chat',
    'coaching.error': 'Failed to get response. Please try again.',

    // Theme
    'theme.light': 'Light',
    'theme.dark': 'Dark',
    'lang.en': 'EN',
    'lang.es': 'ES',
  },

  es: {
    // Layout / Navigation
    'nav.dashboard': 'Panel',
    'nav.assigned_tasks': 'Tareas Asignadas',
    'nav.training': 'Capacitacion',
    'nav.leaderboard': 'Clasificacion',
    'nav.shorts': 'Videos cortos',
    'nav.certificates': 'Certificados',
    'nav.profile': 'Perfil',
    'nav.analytics': 'Estadisticas',
    'nav.modules': 'Modulos',
    'nav.categories': 'Categorias',
    'nav.assignments': 'Asignaciones',
    'nav.associates': 'Asociados',
    'nav.managers': 'Gerentes',
    'nav.thumbnails': 'Miniaturas',
    'nav.associate_view': 'Vista de Asociado',
    'nav.reviews': 'Revisiones de Respuestas',
    'nav.skill_matrix': 'Matriz de Capacitación',
    'nav.sops': 'SOPs y Ayudas Visuales',
    'nav.portal_accounts': 'Acceso de Clientes y Demo',
    'page.portal_analytics': 'Estadisticas de la Cuenta',
    'page.portal_associates': 'Asociados',
    'page.portal_accounts': 'Acceso de Clientes y Demo',
    'nav.observations': 'Observaciones',
    'nav.training_signoff': 'Firmar Entrenamiento',
    'nav.pit_licenses': 'Licencias PIT',
    'nav.kaizens': 'Kaizens',
    'nav.meetings': 'Reuniones',
    'nav.buildings': 'Edificios',
    'nav.media_library': 'Biblioteca de Medios',
    'nav.sign_out': 'Cerrar Sesion',
    'nav.ind4_training': 'Operations Academy',
    'nav.dashboard_subtitle': 'Panel de Capacitación',

    // Page titles
    'page.dashboard': 'Panel',
    'page.assigned_tasks': 'Tareas Asignadas',
    'page.training_modules': 'Modulos de Capacitacion',
    'page.module_viewer': 'Visor de Modulo',
    'page.my_certificates': 'Mis Certificados',
    'page.certificate': 'Certificado',
    'page.my_profile': 'Mi Perfil',
    'page.leaderboard': 'Clasificacion',
    'page.shorts': 'Videos de entrenamiento',
    'page.manage_managers': 'Gestionar Gerentes',
    'page.category_thumbnails': 'Miniaturas de Categorias',
    'page.manage_categories': 'Gestionar Categorias',
    'page.admin_analytics': 'Estadisticas Admin',
    'page.manage_modules': 'Gestionar Modulos',
    'page.manage_assignments': 'Gestionar Asignaciones',
    'page.manage_associates': 'Gestionar Asociados',
    'page.open_answer_reviews': 'Revisiones de Respuestas Abiertas',
    'page.skill_matrix': 'Matriz de Capacitación',
    'page.sops': 'SOPs y Ayudas Visuales',
    'page.media_library': 'Biblioteca de Medios',
    'page.ind4_training': 'Operations Academy',

    // Login
    'login.title': 'Operations Academy',
    'login.subtitle': 'Panel de Capacitación',
    'login.sign_in': 'Iniciar Sesion',
    'login.description': 'Ingrese sus credenciales para acceder a su panel de capacitacion',
    'login.email': 'Correo electronico',
    'login.password': 'Contrasena',
    'login.email_placeholder': 'tu@ejemplo.com',
    'login.password_placeholder': 'Ingrese su contrasena',
    'login.signing_in': 'Iniciando sesion...',
    'login.submit': 'Iniciar Sesion',
    'login.no_account': 'No tienes una cuenta?',
    'login.register_link': 'Registrate aqui',
    'login.welcome_back': 'Bienvenido de nuevo, {name}!',
    'login.fill_fields': 'Por favor complete todos los campos',
    'login.invalid': 'Credenciales invalidas',

    // Register
    'register.title': 'Operations Academy',
    'register.subtitle': 'Panel de Capacitación',
    'register.heading': 'Registrarse',
    'register.description': 'Ingrese sus datos para crear una cuenta de asociado',
    'register.full_name': 'Nombre Completo',
    'register.email': 'Correo electronico',
    'register.job_title': 'Titulo del Puesto',
    'register.password': 'Contrasena',
    'register.confirm': 'Confirmar',
    'register.name_placeholder': 'Juan Perez',
    'register.email_placeholder': 'tu@ejemplo.com',
    'register.password_placeholder': 'Min 6 caracteres',
    'register.confirm_placeholder': 'Confirmar',
    'register.select_job': 'Seleccione su puesto',
    'register.creating': 'Creando cuenta...',
    'register.submit': 'Crear Cuenta',
    'register.has_account': 'Ya tienes una cuenta?',
    'register.login_link': 'Inicia sesion',
    'register.fill_required': 'Por favor complete todos los campos requeridos',
    'register.passwords_mismatch': 'Las contrasenas no coinciden',
    'register.password_length': 'La contrasena debe tener al menos 6 caracteres',
    'register.success': 'Cuenta creada exitosamente!',
    'register.failed': 'Error en el registro',
    // Job titles
    'job.director': 'Director',
    'job.equipment_operator': 'Operador de Equipo',
    'job.inventory_specialist': 'Especialista en Inventario',
    'job.manager': 'Gerente',
    'job.quality_control': 'Control de Calidad',
    'job.supervisor': 'Supervisor',
    'job.team_lead': 'Lider de Equipo',

    // Dashboard
    'dashboard.welcome': 'Bienvenido, {name}',
    'dashboard.overview': 'Aqui esta el resumen de tu progreso de capacitacion',
    'dashboard.total_modules': 'Total de Modulos',
    'dashboard.completed': 'Completados',
    'dashboard.in_progress': 'En Progreso',
    'dashboard.certificates': 'Certificados',
    'dashboard.overall_progress': 'Progreso General',
    'dashboard.modules_completed': '{completed} de {total} modulos completados',
    'dashboard.your_points': 'Tus Puntos',
    'dashboard.view_leaderboard': 'Ver Clasificacion',
    'dashboard.total_points': 'Puntos totales ganados',
    'dashboard.per_module': '+{n} por modulo',
    'dashboard.per_quiz': '+{n} por examen',
    'dashboard.perfect_bonus': '+{n} bono perfecto',
    'dashboard.badges_earned': 'Insignias Ganadas',
    'dashboard.earn_first_badge': 'Completa modulos para ganar tu primera insignia!',
    'dashboard.pending_trainings': 'Capacitaciones Pendientes',
    'dashboard.all_completed': 'Todas las capacitaciones completadas! Buen trabajo.',
    'dashboard.recent_certificates': 'Certificados Recientes',
    'dashboard.no_certificates': 'Sin certificados aun. Completa una capacitacion para obtener uno!',
    'dashboard.view_all_training': 'Ver Todos los Modulos',

    // Status badges
    'status.not_started': 'No Iniciado',
    'status.completed': 'Completado',
    'status.quiz_ready': 'Examen Listo',
    'status.retry': 'Reintentar',
    'status.retry_quiz': 'Reintentar Examen',
    'status.in_progress': 'En Progreso',
    'status.overdue': 'Vencido',
    'status.active': 'Activo',
    'status.inactive': 'Inactivo',

    // Training
    'training.title': 'Modulos de Capacitacion',
    'training.subtitle': 'Explore y complete sus modulos de capacitacion requeridos',
    'training.modules': 'modulos',
    'training.completed_of': '{completed}/{total} completados',
    'training.all': 'Todos',
    'training.no_modules': 'No hay modulos disponibles en esta categoria aun.',
    'training.admin_add_soon': 'El administrador agregara modulos pronto.',
    'training.quiz_questions': '{n} preguntas de examen',
    'training.review': 'Revisar',
    'training.continue': 'Continuar',
    'training.start': 'Iniciar',

    // Profile
    'profile.joined': 'Ingreso {date}',
    'profile.completed': 'Completados',
    'profile.in_progress': 'En Progreso',
    'profile.certificates': 'Certificados',
    'profile.points': 'Puntos',
    'profile.badges_earned': 'Insignias Ganadas',
    'profile.tab_completed': 'Completados',
    'profile.tab_active': 'Activos',
    'profile.tab_certificates': 'Certificados',
    'profile.no_completed': 'Sin capacitaciones completadas aun.',
    'profile.no_active': 'Sin capacitaciones activas.',
    'profile.no_certificates': 'Sin certificados aun. Completa capacitaciones para ganar certificados!',
    'profile.score': 'Puntuacion',
    'profile.picture_updated': 'Foto de perfil actualizada!',
    'profile.picture_failed': 'Error al actualizar foto de perfil',
    'profile.image_too_large': 'La imagen debe ser menor a 2MB',

    // Leaderboard
    'leaderboard.title': 'Clasificacion',
    'leaderboard.subtitle': 'Mira como te clasificas entre tus companeros',
    'leaderboard.you': 'Tu',
    'leaderboard.no_department': 'Sin departamento',
    'leaderboard.pts': 'pts',
    'leaderboard.modules': 'modulos',
    'leaderboard.badges': 'insignias',
    'leaderboard.all_associates': 'Todos los Asociados',
    'leaderboard.no_associates': 'Sin asociados aun.',
    'leaderboard.points': 'puntos',

    // Assigned Tasks
    'assigned.title': 'Tareas Asignadas',
    'assigned.subtitle': 'Modulos de capacitacion asignados por su administrador',
    'assigned.progress': 'Progreso de Asignaciones',
    'assigned.tasks_completed': '{completed} de {total} tareas asignadas completadas',
    'assigned.no_tasks': 'Sin tareas asignadas aun.',
    'assigned.admin_will_assign': 'Su administrador le asignara modulos de capacitacion.',
    'assigned.assigned_date': 'Asignado {date}',
    'assigned.due_date': 'Vence {date}',

    // Certificates List
    'certs.title': 'Mis Certificados',
    'certs.subtitle': 'Vea y descargue sus certificados obtenidos',
    'certs.no_certs': 'Sin certificados obtenidos aun.',
    'certs.earn_certs': 'Complete modulos de capacitacion y apruebe evaluaciones para obtener certificados.',
    'certs.score': 'Puntuacion',

    // Admin Associates
    'admin_assoc.title': 'Asociados',
    'admin_assoc.subtitle': 'Gestione perfiles de asociados y rastree su progreso',
    'admin_assoc.all': 'Todos',
    'admin_assoc.active': 'Activos',
    'admin_assoc.inactive': 'Inactivos',
    'admin_assoc.name': 'Nombre',
    'admin_assoc.email': 'Correo',
    'admin_assoc.department': 'Departamento',
    'admin_assoc.status': 'Estado',
    'admin_assoc.completed': 'Completados',
    'admin_assoc.in_progress': 'En Progreso',
    'admin_assoc.joined': 'Ingreso',
    'admin_assoc.actions': 'Acciones',
    'admin_assoc.no_associates': 'Sin asociados registrados aun.',
    'admin_assoc.no_filter': 'Sin asociados {filter}.',
    'admin_assoc.edit_title': 'Editar Asociado',
    'admin_assoc.account_status': 'Estado de Cuenta',
    'admin_assoc.active_employed': 'Activo — Actualmente empleado',
    'admin_assoc.inactive_terminated': 'Inactivo — Terminado',
    'admin_assoc.unable_login': 'Este asociado no podra iniciar sesion.',
    'admin_assoc.reset_password': 'Restablecer Contrasena',
    'admin_assoc.password_placeholder': 'Dejar en blanco para mantener la contrasena actual',
    'admin_assoc.password_length': 'La contrasena debe tener al menos 6 caracteres',
    'admin_assoc.cancel': 'Cancelar',
    'admin_assoc.update': 'Actualizar',
    'admin_assoc.saving': 'Guardando...',
    'admin_assoc.name_email_required': 'Nombre y correo son requeridos',
    'admin_assoc.deactivated': 'Asociado desactivado exitosamente',
    'admin_assoc.reactivated': 'Asociado reactivado exitosamente',
    'admin_assoc.updated': 'Asociado actualizado',
    'admin_assoc.updated_password': 'Asociado actualizado y contrasena restablecida',
    'admin_assoc.failed_fetch': 'Error al obtener asociados',
    'admin_assoc.failed_update': 'Error al actualizar',
    'admin_assoc.failed_status': 'Error al actualizar estado',
    'admin_assoc.delete_confirm': 'Eliminar este asociado? Se eliminara todo su progreso y certificados.',
    'admin_assoc.deleted': 'Asociado eliminado',
    'admin_assoc.failed_delete': 'Error al eliminar asociado',
    'admin_assoc.deactivated_name': '{name} desactivado',
    'admin_assoc.reactivated_name': '{name} reactivado',

    // Admin Dashboard / Analytics
    'admin_dash.title': 'Panel de Estadisticas',
    'admin_dash.total_associates': 'Total de Asociados',
    'admin_dash.total_modules': 'Total de Modulos',
    'admin_dash.completions': 'Completados',
    'admin_dash.certificates_issued': 'Certificados Emitidos',
    'admin_dash.category_progress': 'Progreso por Categoria',
    'admin_dash.modules_label': 'modulos',
    'admin_dash.completions_label': 'completados',
    'admin_dash.assessment_stats': 'Estadisticas de Evaluacion',
    'admin_dash.avg_score': 'Puntuacion Promedio',
    'admin_dash.total_attempts': 'Intentos Totales',
    'admin_dash.pass_rate': 'Tasa de Aprobacion',
    'admin_dash.passed': 'Aprobados',
    'admin_dash.failed': 'Reprobados',
    'admin_dash.recent_completions': 'Completados Recientes',
    'admin_dash.export_excel': 'Exportar a Excel',
    'admin_dash.no_data': 'Sin datos de completados aun.',

    // Admin Modules
    'admin_mod.title': 'Modulos de Capacitacion',
    'admin_mod.create': 'Crear Modulo',
    'admin_mod.questions': 'preguntas',
    'admin_mod.completions': 'completados',
    'admin_mod.edit': 'Editar',
    'admin_mod.delete': 'Eliminar',
    'admin_mod.no_modules': 'Sin modulos creados aun.',

    // Admin Assignments
    'admin_assign.title': 'Asignaciones',
    'admin_assign.create': 'Crear Asignacion',
    'admin_assign.no_assignments': 'Sin asignaciones aun.',

    // Admin Managers
    'admin_mgr.title': 'Gerentes',
    'admin_mgr.no_managers': 'Sin gerentes aun.',

    // Assessment PDF
    'assessment.title': 'Evaluaciones',
    'assessment.download_pdf': 'Descargar PDF',
    'assessment.view_assessments': 'Ver Evaluaciones',
    'assessment.no_assessments': 'Sin evaluaciones completadas aun.',
    'assessment.score': 'Puntuacion',
    'assessment.attempts': 'Intentos',
    'assessment.result': 'Resultado',
    'assessment.passed': 'Aprobado',
    'assessment.failed': 'Reprobado',
    'assessment.download': 'Descargar',
    'assessment.assessments_for': 'Evaluaciones de {name}',
    'assessment.close': 'Cerrar',
    'assessment.downloading': 'Descargando...',

    // Notifications
    'notif.title': 'Notificaciones',
    'notif.mark_all_read': 'Marcar todo leido',
    'notif.no_notifications': 'Sin notificaciones aun',
    'notif.you_are_caught_up': 'Estas al dia!',

    // Common
    'common.cancel': 'Cancelar',
    'common.save': 'Guardar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.loading': 'Cargando...',
    'common.score': 'Puntuacion',
    'common.search_placeholder': 'Buscar...',

    // Search
    'search.modules_placeholder': 'Buscar modulos por titulo, categoria...',
    'search.associates_placeholder': 'Buscar por nombre, correo, departamento...',

    // Coaching
    'coaching.title': 'Coach de Capacitacion IA',
    'coaching.subtitle': 'Preguntame sobre tu capacitacion!',
    'coaching.input_placeholder': 'Pregunta sobre seguridad, equipo, procesos...',
    'coaching.send': 'Enviar',
    'coaching.thinking': 'Pensando...',
    'coaching.new_chat': 'Nuevo Chat',
    'coaching.error': 'Error al obtener respuesta. Intenta de nuevo.',

    // Theme
    'theme.light': 'Claro',
    'theme.dark': 'Oscuro',
    'lang.en': 'EN',
    'lang.es': 'ES',
  }
};

export default translations;
